/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TripForwardingRelationshipRequest
 */
export interface TripForwardingRelationshipRequest {
    /**
     * 
     * @type {string}
     * @memberof TripForwardingRelationshipRequest
     */
    forwardingEmailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof TripForwardingRelationshipRequest
     */
    source?: TripForwardingRelationshipRequestSourceEnum;
    /**
     * Where to redirect after successful verification
     * @type {string}
     * @memberof TripForwardingRelationshipRequest
     */
    redirectTo?: TripForwardingRelationshipRequestRedirectToEnum;
}


/**
 * @export
 */
export const TripForwardingRelationshipRequestSourceEnum = {
    Web: 'web',
    Mobile: 'mobile'
} as const;
export type TripForwardingRelationshipRequestSourceEnum = typeof TripForwardingRelationshipRequestSourceEnum[keyof typeof TripForwardingRelationshipRequestSourceEnum];

/**
 * @export
 */
export const TripForwardingRelationshipRequestRedirectToEnum = {
    Trips: 'trips',
    AccountInformation: 'account-information'
} as const;
export type TripForwardingRelationshipRequestRedirectToEnum = typeof TripForwardingRelationshipRequestRedirectToEnum[keyof typeof TripForwardingRelationshipRequestRedirectToEnum];


/**
 * Check if a given object implements the TripForwardingRelationshipRequest interface.
 */
export function instanceOfTripForwardingRelationshipRequest(value: object): value is TripForwardingRelationshipRequest {
    if (!('forwardingEmailAddress' in value) || value['forwardingEmailAddress'] === undefined) return false;
    return true;
}

export function TripForwardingRelationshipRequestFromJSON(json: any): TripForwardingRelationshipRequest {
    return TripForwardingRelationshipRequestFromJSONTyped(json, false);
}

export function TripForwardingRelationshipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripForwardingRelationshipRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'forwardingEmailAddress': json['forwarding_email_address'],
        'source': json['source'] == null ? undefined : json['source'],
        'redirectTo': json['redirect_to'] == null ? undefined : json['redirect_to'],
    };
}

export function TripForwardingRelationshipRequestToJSON(json: any): TripForwardingRelationshipRequest {
    return TripForwardingRelationshipRequestToJSONTyped(json, false);
}

export function TripForwardingRelationshipRequestToJSONTyped(value?: TripForwardingRelationshipRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'forwarding_email_address': value['forwardingEmailAddress'],
        'source': value['source'],
        'redirect_to': value['redirectTo'],
    };
}

